import React, { useEffect, useMemo, useState } from "react";
import useDeleteLocationApi from "../../Global/Api/Settings/deleteLocation";
import useSetMainApi from "../../Global/Api/Settings/setMainLocation";
import { useGetLocationsQuery } from "../../Store/Builder/techsbook.api";

export default function LocationItem({
  openPopup,
  setAddress,
  currentAddress,
  setCurrentAddress,
}) {
  const [locationsData, setLocationsData] = useState([]);
  const { data, isLoading: locationsIsLoading } = useGetLocationsQuery();

  const setMainApi = useSetMainApi();
  const deleteApi = useDeleteLocationApi();

  const handleMain = (id) => {
    setMainApi.send({ id });
  };

  useEffect(() => {
    let isMain = data?.filter((item) => item.is_main)[0];
    let otherLocation = data?.filter((item) => !item.is_main);
    if (isMain) {
      setLocationsData([isMain, ...otherLocation]);
    }
  }, [data]);

  const handleDelete = (id) => {
    deleteApi.send({ id });
  };
  const renderLocations = useMemo(
    () =>
      locationsData?.map((item, index) => (
        <div key={index} className="locations__table-item">
          <p className="locations__table-itemText">{item?.address.replaceAll('undefined', '')}</p>
          <p className="locations__table-itemText">{item?.city}</p>
          <p className="locations__table-itemText">{item?.state}</p>
          <p className="locations__table-itemText">{item?.zip_code}</p>
          <p className="locations__table-itemText">{item?.country}</p>
          {item?.is_main && (
            <div className="locations__table-itemMain">Main</div>
          )}
          <div className="locations__table-itemBtns">
            {!item?.is_main && (
              <div
                onClick={() => {
                  handleMain(item?.id);
                }}
                className="locations__table-itemBtn"
              >
                <img src="../../assets/icons/star.svg" alt="star" />
              </div>
            )}
            <div
              onClick={() => {
                setAddress(item);
                setCurrentAddress(item);
                openPopup(true);
              }}
              className="locations__table-itemBtn"
            >
              <img src="../../assets/icons/edit-2.svg" alt="edit" />
            </div>
              {
                  !item?.is_main && (
                  <div
                      onClick={() => {
                          handleDelete(item?.id);
                      }}
                      className="locations__table-itemBtn"
                  >
                      <img src="../../assets/icons/trash.svg" alt="trash" />
                  </div>
              )
              }
          </div>
        </div>
      )),
    [locationsData]
  );
  return (
    <>
      {locationsData?.length === 0 ? (
        <div style={{ padding: "20px 0" }}>
          <div>
            <img src="/assets/images/empty-location.svg" alt="icon" />
          </div>
          <p className="technicians-empty-text">No Locations</p>
        </div>
      ) : (
        renderLocations
      )}
    </>
  );
}
